module.exports = function store(state, emitter) {
  emitter.on("next-level", () => {
    if (state.sharingMode && state.sharingMode.active) {
      return;
    }
    state.levelComplete = true;
    emitter.emit("pause");
    emitter.emit("render");
  });

  emitter.on("go-to-next-level", () => {
    state.levelComplete = false;
    const currentSceneIndex = state.project.scenes.indexOf(state.currentScene);
    state.currentLevel = currentSceneIndex + 1;
    if (state.projectMetadata.tutorials) {
      const nextTutorial = state.projectMetadata.tutorials[state.currentLevel];

      if (nextTutorial) {
        state.currentTutorial = nextTutorial;
        if (state.currentTutorial) {
          state.currentTutorialStep = state.currentTutorial.startingStepId;
          state.toolbar =
            state.currentTutorial[state.currentTutorialStep].toolbar;
        }
      }
    }
    emitter.emit("load-scene", state.currentLevel);
    emitter.emit("render");
  });
};
